<template>
	<div>
		<div class="gPageBorder">
			<el-row style="margin-bottom:24px">

				<el-col :span="20" style="">
					<el-button class='gSgLeftBtn' type="primary" @click="open_add">
						{{$t('app_new')}}
					</el-button>
					<el-button :disabled="delete_list.length == 0" @click="delete_select">
						{{$t('app_mulDel')}}
					</el-button>
				</el-col>
				<el-col :span="4">
					<div class='gSideCtrl'>
						<el-input :placeholder="$t('app_name')" v-model='select_form.secretName'
							@keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
					</div>
				</el-col>

			</el-row>


			<el-table class='' v-loading="loading" :data="tableData2" @selection-change="handleDevice" id="tp"
				@row-click='cellClick' border style="margin-bottom: 20px;">

				<el-table-column type="selection" width="55">
				</el-table-column>

				<el-table-column prop="secretName" align="center" header-align="center" :label="$t('app_secrname')">

				</el-table-column>
				<el-table-column prop="keyType" align="center" header-align="center" :label="$t('app_keyType')">
					<template slot-scope="scope">
						<label for="">{{ get_key_type(scope.row.keyType) }} </label>
					</template>
				</el-table-column>
				<el-table-column prop="encryptionIndex" align="center" header-align="center"
					:label="$t('app_keyUpIndex')">

				</el-table-column>
				<el-table-column prop="downloadIndex" align="center" header-align="center"
					:label="$t('app_keyDlIndex')">

				</el-table-column>
				<el-table-column prop="algorithmModel" align="center" header-align="center"
					:label="$t('app_Algorithm_mode')">
					<template slot-scope="scope">
						<label for="">{{ get_an(scope.row.algorithmModel) }} </label>
					</template>
				</el-table-column>

				<el-table-column header-align="center" align="center" :label="$t('lin_global.ope')" width="110">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" :content="$t('mao_global.btn.edit')" placement="top">
							<el-button type='text' @click="editRow(scope.row)"><i class="fa fa-pencil" style=""></i>
							</el-button>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
							<el-button type='text' @click="deleteRow(scope.row.id)"><i class="fa fa-trash"
									style="color:#FF4949"></i></el-button>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>
			<div class="gPgDiv">
				<el-pagination style='' class='gPg' @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,50,100]"
					:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
				</el-pagination>
			</div>
		</div>



	</div>
</template>

<script>
	import axios from 'axios'
	import {
		baseurl,
		focusEvent,
		urlAssets
	} from '../../api/url'
	import city from '../city.js'
	// import sFile from 'save-file'
	import AutoTerno from '../global/TernoAutoCtrl'
	export default {
		components: {
			AutoTerno,
		},
		data() {
			var that = this
			return {
				tableData2: [],
				delete_list: [],
				pageSize: 10,
				currentPage: 0,
				totalRecords: 0,
				pushdev: false,
				push_list: [],
				ttpage: 20,
				tableData: [],
				total: 0,
				page: 1,
				isNon: false,
				pushImport: false,
				fileList: [],
				uldata: '',
				snum: 0,
				downTpl: `${urlAssets.prefix}tms-server-web/model/terminalNos.xlsx`,
				importTemplate: `${urlAssets.prefix}tms-server-web/import/terminalList.do`,
				formLabelWidth: '28.5%',

				mechanismData: {
					callback(value) {
						that.select_form.mechId = value
						// that.query()
					}
				},
				mechanismData_2: {
					callback(value) {
						that.form.mechId = value
						that.get_device_list()
					}
				},
				mech: '',
				ctyps: [{
						vl: '0',
						lb: this.$t('app_status_update')
					},
					{
						vl: '1',
						lb: this.$t('app_status_updated')
					},
					{
						vl: '2',
						lb: this.$t('app_status_exist')
					},
					{
						vl: '3',
						lb: this.$t('app_status_fail')
					}
				],
				ctype: '',
				queryKey: '',
				ahref: '',
				select_form: {
					secretName: "",
				},
				focusEvent: focusEvent,
				loading: true,
				keyType_list: [{
						id: 0,
						label: "PIN",
						value: 0
					},
					{
						id: 1,
						label: "MAC",
						value: 1
					},
					{
						id: 2,
						label: "TD",
						value: 2
					},
					{
						id: 3,
						label: "MAIN",
						value: 3
					},
					{
						id: 4,
						label: "PTK",
						value: 4
					},
					{
						id: 5,
						label: "CBC_TD",
						value: 130
					},
					{
						id: 6,
						label: "CBC_PIN",
						value: 128
					},
					{
						id: 7,
						label: "CBC_MAC",
						value: 129
					}
				],
				An_list: [{
						id: 0,
						label: "MODE_3DES",
						value: 1
					},
					{
						id: 1,
						label: "MODE_SM4",
						value: 2
					},
					{
						id: 2,
						label: "MODE_AES",
						value: 3
					},
					{
						id: 3,
						label: "MODE_DUKPT_DES",
						value: 8193
					},
					{
						id: 4,
						label: "MODE_DUKPT_SM4",
						value: 8194
					},
					{
						id: 5,
						label: "MODE_FIXED_DES",
						value: 16385
					},
					{
						id: 6,
						label: "MODE_FIXED_SM4",
						value: 16386
					}
				],
			}
		},
		created() {
			this.getData();
		},
		methods: {
			// 密钥类型格式化
			get_key_type(index) {
				var result = ""
				for (var i = 0; i < this.keyType_list.length; i++) {
					if (index == this.keyType_list[i].value) {
						result = this.keyType_list[i].label
					}
				}
				return result;
			},
			// 算法模式格式化
			get_an(index) {
				var result = ""
				for (var i = 0; i < this.An_list.length; i++) {
					if (index == this.An_list[i].value) {
						result = this.An_list[i].label
					}
				}
				return result;
			},
			// 点击行跳转
			cellClick(row, ev, col) {
				if (!col.label || col.label === this.$t('app_operate')) {
					return
				}

				this.$router.push({
					path: '/keyManagement/detail',
					query: {
						kid: row.id,
						kName: row.secretName
					}
				})

			},

			// 打开添加页面
			open_add() {
				this.$router.push({
					path: '/keyManagement/add',
					// query: {
					// 	tid: row.taskId,
					// 	tty: row.taskType
					// }
				})
			},
			query() {
				this.getData()
			},
			// 删除密钥勾选
			handleDevice(val) {
				this.delete_list = val;
				console.log(this.delete_list)
			},
			// 批量删除密钥
			delete_select() {
				let terminal_list = []
				for (var i = 0; i < this.delete_list.length; i++) {
					terminal_list.push(this.delete_list[i].id)
				}
				this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/secret/delete.do`, {
						id: String(terminal_list)
					}).then(res => {
						//console.log("打印看看删除返回信息")
						//console.log(res.data);
						if (res.data.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'));
							this.getData();
						} else {
							this.$message.error(res.data.message)
						}
					})
				})
			},
			// 删除密钥
			deleteRow(id) {
				this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/secret/delete.do`, {
						id: id
					}).then(res => {
						//console.log("打印看看删除返回信息")
						//console.log(res.data);
						if (res.data.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'));
							this.getData();
						} else {
							this.$message.error(res.data.message)
						}
					})
				}).catch(() => {

				})
			},
			// 编辑密钥
			editRow(data) {
				console.log(data)
				this.$router.push({
					path: '/keyManagement/edit',
					query: {
						data: data,
						 
					}
				})
			},
			// 修改每页显示个数
			handleSizeChange: function(val) {
				this.pageSize = val
				this.getData()
			},
			// 翻页
			handleCurrentChange: function(val) {
				this.currentPage = val
				this.getData()
			},

			getData() {
				// this.currentPage = page;
				var data = {
					page: this.currentPage,
					rows: this.pageSize,
					secretName: this.select_form.secretName,
				};
				axios.post(`${baseurl}/secret/pageList.do`, data).then(res => {
					//console.log("打印返回列表2");
					//console.log(res.data);
					if (res.data.status == 200) {
						this.tableData2 = res.data.data;
						this.totalRecords = res.data.total;
						this.loading = false;
					} else {
						this.loading = false;
					}

				})
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// keyManagement.vue?ca8272be